import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { documentationActions } from '../../actions/constant';
import templateService from 'src/services/apiServices/document-management/template-service';
const {
 ADD_SIGN_ON_BEHALF_REQUEST,
  ADD_SIGN_ON_BEHALF_SUCCESS,
  ADD_SIGN_ON_BEHALF_FAILURE,
  ADD_SIGN_ON_BEHALF_LOADING,
  ADD_SIGN_ON_BEHALF_RESET,
} = documentationActions;

function* addSignOnBehalf(action: any): SagaReturnType<any> {
  try {
    yield put({ type: ADD_SIGN_ON_BEHALF_LOADING })
    const response = yield call(templateService.signOnBehalf, action.payload);
    if (response?.status === 200) {
      yield put({ type: ADD_SIGN_ON_BEHALF_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: ADD_SIGN_ON_BEHALF_FAILURE, payload: error });
  }
}

function* addSignOnBehalfSaga() {
  yield takeEvery(ADD_SIGN_ON_BEHALF_REQUEST, addSignOnBehalf);
}

export default addSignOnBehalfSaga;
